// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__308sZ","hover":"Menu_hover__eoVQv"};